// admin/* page translations
const admin = {
  index: {
    title: 'Administrator Page',
    subtitle: 'Company and data management',
    tab: {
      company: 'Companies',
      data: 'Data Verification',
    },
  },
  companyManagement: {
    statusLabel: 'Status',
    statusAll: 'All',
    statusActive: 'Active',
    statusInactive: 'Inactive',
    searchPlaceholder: 'Search company name or code',
    addBtn: 'Add Company',
    col: {
      name: 'Company Name',
      code: 'Company Code',
      ceo: 'CEO',
      businessNumber: 'Business Number',
      address: 'Address',
      phone: 'Phone',
      employees: 'Employees',
      status: 'Status',
      createdDate: 'Registered',
      action: 'Actions',
    },
    employeesSuffix: '{n}',
    stats: {
      total: 'Total Companies',
      active: 'Active',
      inactive: 'Inactive',
      employees: 'Total Employees',
    },
    deleteModal: {
      title: 'Confirm Company Deletion',
      messagePrefix: 'Are you sure you want to delete this company?',
      submessage: 'This action cannot be undone.',
      cancel: 'Cancel',
      confirm: 'Delete',
    },
  },
  companyRegister: {
    title: 'Register Company',
    subtitle: 'Register new company information',
    sectionBasic: 'Basic Information',
    sectionContact: 'Contact Information',
    sectionOperation: 'Operation Information',
    fields: {
      name: 'Company Name',
      code: 'Company Code',
      ceo: 'CEO',
      businessNumber: 'Business Number',
      address: 'Address',
      phone: 'Phone',
      employees: 'Employees',
      status: 'Status',
    },
    placeholder: {
      name: 'Enter company name',
      code: 'Enter company code',
      ceo: 'Enter CEO name',
      businessNumber: '123-81-00998',
      address: 'Enter address',
      phone: '031-200-1114',
      employees: 'Enter number of employees',
    },
    statusActive: 'Active',
    statusInactive: 'Inactive',
    cancel: 'Cancel',
    submit: 'Register',
    error: {
      nameRequired: 'Please enter company name',
      codeRequired: 'Please enter company code',
      ceoRequired: 'Please enter CEO name',
      businessNumberRequired: 'Please enter business number',
      businessNumberInvalid: 'Invalid business number format (e.g., 123-81-00998)',
      addressRequired: 'Please enter address',
      phoneRequired: 'Please enter phone number',
      phoneInvalid: 'Invalid phone number format (e.g., 031-200-1114)',
      employeesRequired: 'Please enter number of employees',
      employeesInvalid: 'Please enter a valid number of employees',
    },
  },
  companyDetail: {
    title: 'Company Details',
    subtitle: 'View and edit company information',
    delete: 'Delete',
    edit: 'Edit',
    cancel: 'Cancel',
    save: 'Save',
    profile: {
      codeLabel: 'Company Code: {code}',
      registeredOn: 'Registered',
      employees: 'Employees',
    },
    sectionBasic: 'Basic Information',
    sectionContact: 'Contact Information',
    sectionOperation: 'Operation Information',
    fields: {
      name: 'Company Name',
      code: 'Company Code',
      ceo: 'CEO',
      businessNumber: 'Business Number',
      address: 'Address',
      phone: 'Phone',
      employees: 'Employees',
      status: 'Status',
      createdDate: 'Registered',
    },
    statusActive: 'Active',
    statusInactive: 'Inactive',
    employeesSuffix: '{n}',
    confirmDelete: 'Are you sure you want to delete this company?',
  },
  dataVerification: {
    placeholder: 'Coming soon',
  },
};

export default admin;
